// 게임 시간 시계(COMBAT-FEEL 2.1). 코어가 채우는 누적 유효 틱(GameView.heroTime/worldTime)을 읽는다.
// 표시 시간 = heroTime - heroRate*(1-alpha), worldTime - worldRate*(1-alpha). 한 프레임에 여러 틱이 지나도 틱별 배율이 그대로 반영된다.
// 전투 VFX·애니메이션은 이 시계로 움직이고(일시정지·히트스톱에 멈춤), 섬광 리미터·UI만 실시간(realMs)을 쓴다.
import type { GameView } from '../shared/types';

const MAX_DELTA = 30; // 탭 복귀 등 큰 점프는 잘라낸다(틱)

export class GameClocks {
  /** 직전 step의 진행 비율 */
  heroRate = 1;
  worldRate = 1;
  /** 이번 프레임 보간을 반영한 시각(틱) */
  heroNow = 0;
  worldNow = 0;
  /** 직전 프레임 대비 진행량(틱) */
  heroDelta = 0;
  worldDelta = 0;
  /** 실시간 누적(ms) */
  realMs = 0;
  private heroTime = 0;
  private worldTime = 0;
  private lastTick = 0;
  private inited = false;

  update(view: GameView, alpha: number, frameDt: number): void {
    const hr = Number.isFinite(view.heroRate) ? view.heroRate : 1;
    const wr = Number.isFinite(view.worldRate) ? view.worldRate : 1;
    const ht = Number.isFinite(view.heroTime) ? view.heroTime : view.tick;
    const wt = Number.isFinite(view.worldTime) ? view.worldTime : view.tick;
    this.heroRate = hr;
    this.worldRate = wr;
    const hn = ht - hr * (1 - alpha);
    const wn = wt - wr * (1 - alpha);
    if (!this.inited || hn < this.heroNow - MAX_DELTA || wn < this.worldNow - MAX_DELTA) {
      // 처음이거나 새 게임으로 시간이 되감겼다
      this.heroNow = hn;
      this.worldNow = wn;
      this.heroDelta = 0;
      this.worldDelta = 0;
      this.inited = true;
    } else {
      this.heroDelta = Math.min(MAX_DELTA, Math.max(0, hn - this.heroNow));
      this.worldDelta = Math.min(MAX_DELTA, Math.max(0, wn - this.worldNow));
      if (hn > this.heroNow) this.heroNow = hn;
      if (wn > this.worldNow) this.worldNow = wn;
    }
    this.heroTime = ht;
    this.worldTime = wt;
    this.lastTick = view.tick;
    this.realMs += frameDt * 1000;
  }

  /** 이벤트가 생긴 시뮬레이션 틱의 영웅 시각(한 프레임에 여러 틱이 지나도 VFX가 제때 시작한다). */
  heroAt(evTick: number): number {
    return this.heroTime - Math.max(0, this.lastTick - evTick) * this.heroRate;
  }

  /** 이벤트가 생긴 시뮬레이션 틱의 세계 시각(세계 시계로 세는 상태 — 기상 무적 등 — 의 늦게 온 만큼을 잴 때) */
  worldAt(evTick: number): number {
    return this.worldTime - Math.max(0, this.lastTick - evTick) * this.worldRate;
  }
}
